import '@babel/polyfill'
import * as React from "react";
import "./App.css";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import { Provider } from "react-redux";
import configureStore from "./utils/configureStore";
import { MuiThemeProvider } from "@material-ui/core/styles";
import theme from './common/theme'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import * as moment from 'moment'
import "moment/locale/fi";
import Routes from "./Routes_fix";
import * as gaUtils from './utils/gaUtils';
import MomentUtils from '@date-io/moment';

// Initialize Google Analytics
gaUtils.initializeGA();

const history = createBrowserHistory();

// Set Google Analytics to track page views.
gaUtils.trackPages(history);

const store = configureStore(history);

moment.locale("fi");

class App extends React.Component {
  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils} locale="fi">
          <Provider store={store}>
            <ConnectedRouter store={store} history={history} children={<Routes />} />
          </Provider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx